/* Used global Wordpress php variables to the ajax requests */
/* global themeVars */

/**
 * Theme Settings
 */

const themeSettings = { ...themeVars }

export { themeSettings };
